import React from "react";
import { useTranslation } from "react-i18next";

export default function SettingsCard({
    label,
    description,
    logo,
    value = "",
    measureUnit = null,
    onChange,
    inputType = "text",
    placeholder = "",
    step = 1,
    rangeMin = 0,
    rangeMax = 1,
    rows= 1
}) {

    const [t] = useTranslation("global");

    const checkboxLabel = value ? t("setting.status.enabled") : t("setting.status.disabled");
    const inputId = `settings-card-${label.replace(/\s+/g, "-").toLowerCase()}`;


    let input = () => {
        switch (inputType) {
            case "checkbox": return <div className="col-auto">
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id={inputId}
                        checked={Boolean(value)}
                        onChange={onChange}
                    />
                    <label className="form-check-label ms-2" htmlFor={inputId}>
                        {checkboxLabel}
                    </label>
                </div>
            </div>
            case "number":
            case "text": return <>
                <div className="col-auto">
                    <input
                        id={inputId}
                        type={inputType}
                        className="form-control"
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        step={inputType === "number" ? step || "any" : undefined}
                    />
                </div>
                {measureUnit && (
                    <div className="col-auto text-muted">{measureUnit}</div>
                )}
            </>
            case "range": return <>
                <div className="col-auto">
                    <input
                        id={inputId}
                        type={inputType}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        step={step}
                        min={rangeMin}
                        max={rangeMax}
                    />
                </div>
                <div className="col-auto text-muted">{`${value} ${measureUnit || ''}`}</div>
            </>
            case "text-area": return <>
                <div className="col-auto input-group">
                    <textarea
                        id={inputId}
                        className="form-control"
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        rows={rows}
                    />
                </div>
            </>
        }
    }


    return (
        <div className="card bg-dark text-white h-100 d-flex flex-column">
            <div className="card-body d-flex flex-column">
                <div className="row align-items-center">
                    {logo && (
                        <div className="col-auto text-muted">
                            <h2 className="mb-0">{logo}</h2>
                        </div>
                    )}

                    <div className="col">
                        <h5 className="card-title">{label}</h5>
                    </div>
                </div>

                <p className="card-text text-muted flex-grow-1 mt-2">{description}</p>

                <div className="row align-items-center mt-auto">
                    {input()}
                </div>
            </div>
        </div>
    );
}
